// extracted by mini-css-extract-plugin
export default {"content":"Settings_content__SGly-","form":"Settings_form__olOsp","ids":"Settings_ids__sgkSl","onlyadmin":"Settings_onlyadmin__vp+V7"};